import { render } from "./DeleteUserModal.vue?vue&type=template&id=db22b0f6&scoped=true"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js"

import "./DeleteUserModal.vue?vue&type=style&index=0&id=db22b0f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db22b0f6"]])

export default __exports__